{
    "AgentList_AddButton_DisabledTooltip": "Please select a telephony server and partition in the filters above to add an agent.",
    "AgentList_Column_AgentNumber": "Agent number",
    "AgentList_Column_PartitionId": "Partition ID",
    "AgentList_Column_Monitored": "Monitored",
    "AgentList_Monitored_Yes": "Yes",
    "AgentList_Monitored_No": "No",
    "AgentList_Column_Description": "Description",
    "AgentList_Column_InternalNumber": "Internal number",
    "AgentList_Column_PartitionName": "Partition name",
    "AgentList_Column_OmniChannel": "Omni-channel",
    "NAME": "AgentListLanguage"
}
